import { Spin } from "antd";
import { Col } from "reactstrap";
import CreatableSelect from "react-select/creatable";

const CreatableSelectField = ({ ...props }) => {
  const {
    label,
    name,
    formik,
    options = [],
    placeholder = "Sélectionner ou ecrire pour créer",
    colSize = 12,
    error,
    onChange,
    onCreateOption,
    isClearable = true,
    isDisabled = false,
    isLoading = false,
    isError = false,
    errorApi = false,
  } = props;

  const handleChange = (selectedOption) => {
    const value = selectedOption?.value || "";
    if (onChange) onChange(value);
    else formik.setFieldValue(name, value);
  };

  const selectedValue = formik.values[name];
  const selectedOption = options.find(opt => opt.value === selectedValue) || null;

  return (
    <Col lg={colSize}>
      <div className="mb-3">
        <label htmlFor={name} className="form-label">{label}</label>
        <div className="d-flex align-items-center">
          <div style={{ flex: 1}}>
            <CreatableSelect
              id={name}
              name={name}
              value={selectedOption}
              onChange={handleChange}
              onCreateOption={onCreateOption}
              onBlur={formik.handleBlur}
              options={options}
              isClearable={isClearable}
              placeholder={placeholder}
              isDisabled={isDisabled}
              isLoading={isLoading}
              noOptionsMessage={() =>
                isLoading
                  ? "Chargement..."
                  : "Aucune donnée disponible pour l’instant"
              }
              styles={{
                control: (provided, state) => ({
                  ...provided,
                  minHeight: 44,
                  height: 44,
                  borderRadius: 8,
                }),
                input: (provided) => ({
                  ...provided,
                  margin: 0,
                  padding: 0,
                }),
                valueContainer: (provided) => ({
                  ...provided,
                  height: 44,
                  padding: '0 8px',
                }),
              }}
            />
          </div>

          {isLoading && <Spin size="small" className="ms-2" />}
        </div>

        {isError && (
          <div className="text-danger mt-1">
            {errorApi?.message || "Erreur lors du chargement des données"}
          </div>
        )}

        {formik.touched[name] && error && (
          <div className="text-danger mt-1">{error}</div>
        )}
      </div>
    </Col>
  );
};

export default CreatableSelectField;
